import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { RicercautentiPage } from "../ricercautenti/ricercautenti";
import { UtentiPage } from "../utenti/utenti";

/**
 * Generated class for the ResetpasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-resetpassword',
  templateUrl: 'resetpassword.html',
})
export class ResetpasswordPage {
  userAdmin;
  searchTerm;
  rpassword;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider

    ) {
    this.userAdmin = navParams.get('userAdmin');
    this.userAdmin.password="";
    this.searchTerm = navParams.get('searchTerm');
  }
  updateUserAdmin() {
    if(this.userAdmin.password==this.rpassword){
      if(this.rpassword.length<6){
        alert("Password deve essere lungo almeno 6 caratteri")
      }else{
        //aggiorna
        this.rest.restPasswordUser(this.userAdmin);
        if(this.searchTerm!=null){
          this.navCtrl.push(RicercautentiPage,{searchTerm:this.searchTerm}).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 3, 3); });

        }else{
          this.navCtrl.push(UtentiPage,{searchTerm:this.searchTerm}).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });

        }

      }
    }else{
      alert("Password di conferma errato");
    }

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad ResetpasswordPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/resetpassword/resetpassword.ts